import PropTypes from 'prop-types'
import classnames from 'classnames'

const ThumbPicture = ({ src, name, description, rounded }) => {
  const pictureClasses = classnames(
    'thumb-picture',
    { 'is--rounded': rounded }
  )

  const renderDescription = () => description !== '' && (
    <figcaption>{ description }</figcaption>
  )

  return (
    <figure className={ pictureClasses }>
      <img src={ src } alt={ name } title={ name } />
      { renderDescription() }
    </figure>
  )
}

ThumbPicture.defaultProps = {
  description: '',
  rounded: true
}

ThumbPicture.propTypes = {
  src: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  rounded: PropTypes.bool
}

export default ThumbPicture
